export default "__VITE_ASSET__DODr38cl__"